/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useEffect } from "react";
import { NavigationType, useLocation, useNavigationType } from "react-router-dom";

export function useScrollToTop(customIdentifier?: number) {
  const { pathname } = useLocation();
  const navType = useNavigationType();

  useEffect(() => {
    if (navType === NavigationType.Push || customIdentifier !== undefined) {
      setTimeout(scrollToTop, 0);
    }
  }, [pathname, navType, customIdentifier]);
}

const scrollToTop = () => document.documentElement.scrollTo({ top: 0 });
